<template>
  <div>
    <div :class="{'has-error':errors.fieldset}">
      <select
        :value="fieldset"
        :class="{'required': true}"
        name="fieldset"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected">
          Select One
        </option>
        <option
          v-for="(info, $id) in config.teamRepFieldsets.fields"
          :value="$id"
        >
          {{ info.label }}
        </option>
      </select>
    </div>
    <div v-if="fieldset" :class="{'has-error':errors.compliantChoices}">
      is one of
      <div v-for="(label, value) in config.teamRepFieldsets.fields[fieldset].choices">
        <input
          v-model="selectedCompliantChoices"
          :value="value"
          type="checkbox"
          name="compliantChoices"
        >
        <label>{{ label }}</label>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      fieldset: Number,
      compliantChoices: {
        type: Array,
        default: () => []
      },
      id: String,
    },
    data: function () {
      return {
        selectedCompliantChoices: this.compliantChoices,
      }
    },
    watch: {
      'selectedCompliantChoices': function() {
        this.$emit('update:compliantChoices', this.selectedCompliantChoices);
      },
      'compliantChoices': function(value) {
        this.selectedCompliantChoices = value;
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.fieldset) {
          this.errors.fieldset = 'Please select a field.';
        } else {
          if (this.compliantChoices.length < 1) {
            this.errors.compliantChoices = "Please select at least one valid choice.";
          }
        }
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
